module.exports = __webpack_public_path__ + "img/logo.402c7d11.png";